import type { UseIntl } from '../../../types';
import { FieldTypes, FieldErrorsTypes } from './types';
import {
  validateEmail, validateUsername, validatePassword, validateConfirmPassword,
} from './validators';

/**
 * It accepts complete registration data as payload and checks if the form is valid.
 */
export const isFormValid = (payload: FieldTypes, intl: UseIntl)
: { fieldErrors: FieldErrorsTypes; isValid: boolean } => {
  const fieldErrors = {} as FieldErrorsTypes;

  Object.keys(payload).forEach((key: string) => {
    switch (key) {
      case 'email': {
        fieldErrors.email = validateEmail(intl, payload.email);
        break;
      }
      case 'username':
        fieldErrors.username = validateUsername(intl, payload.username);
        break;
      case 'password':
        fieldErrors.password = validatePassword(intl, payload.password);
        break;
      case 'confirm_password':
        fieldErrors.confirm_password = validateConfirmPassword(intl, payload.password, payload.confirm_password);
        break;
      default:
        break;
    }
  });

  const isValid = Object.values(fieldErrors).every((err) => !err);

  return { isValid, fieldErrors };
};

/**
 * It accepts current language and language list as payload and returns selected language name.
 */
interface Language {
  code: string;
  name: string;
}

export const getSelectedLanguage = (currentLanguage: string, languageList: Language[]): string => (
  languageList.find(({ code }) => code === currentLanguage)?.name || 'English'
);
